<template>
  <footer class="block py-4">
    <div class="container mx-auto px-4">
      <hr class="mb-4 border-b-1 border-blueGray-200" />
      <div
        class="flex flex-wrap items-center justify-between"
      >
        <div class="w-full md:w-6/12 px-4">
          <div
            class="text-sm text-blueGray-500 font-semibold py-1 text-center md:text-left"
          >
            Copyright © {{ date }}
            <a
              href="https://mylockersolution.com/"
              class="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold py-1"
            >
              My Locker Solution
            </a>
          </div>
        </div>
        <div class="w-full md:w-6/12 px-4">
          <div
              class="text-sm text-blueGray-500 font-semibold py-1 text-center md:text-left"
          >
            <div class="text-right">
              <select v-model="$i18n.locale">
                <option v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang">{{ lang.toUpperCase() }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
      languages: ['en', 'it'],
    };
  },
};
</script>
